import React, { useState } from "react";
import { Form, Input, Space, Button, Image, message } from "antd";
import baseRequest from "../../utils/baseRequest";
import { JSEncrypt } from "jsencrypt";
export default function GetPhoneNumber() {
  // const [phoneNumber, setPhoneNumber] = useState();
  //在modal中搜索用户
  const [userInfo, setUserInfo] = useState();
  //选中用户
  const [selectedUser, setSelectedUser] = useState();
  const handleSelected = () => {
    if (selectedUser) {
      setSelectedUser();
      form.resetFields();
      return;
    }
    setSelectedUser(userInfo.mid);
    form.setFieldsValue({
      mobile_phone: userInfo.mobile_phone,
    });
  };
  const [form] = Form.useForm();
  const handleSubmit = async (value) => {
    if (!selectedUser) {
      alert("还未选中用户");
      return;
    }
    //对手机号进行RSA加密
    const encrypt = new JSEncrypt();
    encrypt.setPublicKey(process.env.REACT_APP_RSA_KEY);
    const encrypted_mobile_phone = encrypt.encrypt(value.mobile_phone);
    const encrypted_new_mobile_phone = encrypt.encrypt(value.new_mobile_phone);
    console.log(value.mobile_phone, value.new_mobile_phone);
    try {
      const base = baseRequest();
      const _response = await fetch("/op/login/reset_mobile_phone", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          mobile_phone: encrypted_mobile_phone,
          new_mobile_phone: encrypted_new_mobile_phone,
          region_code: "86",
          ...base,
        }),
      });
      const _data = await _response.json();
      if (_data.ret === -1) {
        alert(_data.msg);
        return;
      }
      message.success("更新成功");
      setSelectedUser();
    } catch (error) {
      console.error(error);
    }
  };
  //搜索
  const search = async (value) => {
    try {
      const base = baseRequest();
      const response = await fetch("/op/account/get_mobile_phone_by_user_id", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          user_id: parseInt(value.user_id, 10),
          ...base,
        }),
      });
      const data = await response.json();
      if (data.ret === -1) {
        alert(data.msg);
        return;
      }
      setUserInfo(data.data);
      setSelectedUser();
      // setPhoneNumber(
      //   data.data.mobile_phone === ""
      //     ? "未查询到手机号，请检查ID是否正确"
      //     : data.data.mobile_phone
      // );
    } catch (error) {
      console.error(error);
    }
  };
  //表单提交失败
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  return (
    <div className="mt-4" style={{ marginLeft: 20, marginRight: 20 }}>
      <Form name="search" onFinish={search} onFinishFailed={onFinishFailed}>
        <Space style={{ marginBottom: 20 }}>
          <Form.Item label="ID" name="user_id" style={{ margin: 0 }}>
            <Input type="number" allowClear />
          </Form.Item>
          <Button type="primary" htmlType="submit">
            搜索
          </Button>
        </Space>
      </Form>
      <p className="text-red-400">
        该功能仅限内部出于售后目的使用，请勿泄漏用户手机号
      </p>
      <div className="max-w-max py-8">
        {userInfo && (
          <div
            className={`flex flex-row items-center p-2 rounded-xl max-w-max ${
              selectedUser ? "bg-green-300" : "bg-gray-300"
            }`}
          >
            <Image
              className="rounded-lg"
              src={userInfo?.avatar?.images[0].urls[0]}
              width={80}
              height={80}
            />
            <div className="flex flex-col justify-center mx-4">
              <p className="text-lg font-bold">ID：{userInfo.user_id}</p>
              <p className="text-lg font-bold">昵称：{userInfo.name}</p>
            </div>
            <Button
              type={selectedUser ? "default" : "primary"}
              onClick={handleSelected}
            >
              {selectedUser ? "取消选中" : "选中用户"}
            </Button>
          </div>
        )}
        <Form
          className="mt-4 flex flex-col"
          form={form}
          onFinish={handleSubmit}
          initialValues={userInfo}
          style={{ display: selectedUser ? "block" : "none" }}
        >
          <Space>
            <Form.Item name="mobile_phone" label="旧手机号">
              <Input disabled />
            </Form.Item>
            <Form.Item
              name="new_mobile_phone"
              label="新手机号"
              rules={[
                {
                  required: true,
                  pattern: /^1[3456789]\d{9}$/,
                  message: "请填写正确的11位手机号",
                },
              ]}
            >
              <Input placeholder="请输入新手机号" />
            </Form.Item>
          </Space>
          <Button type="primary" htmlType="submit" className="ml-2">
            确认
          </Button>
        </Form>
      </div>
    </div>
  );
}
